import React from 'react';
import { objectOf, any, string, number } from 'prop-types';
import classNames from 'classnames';

import { Spinner, SpinnerSize } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const UnstyledLoading = ({
  classes,
  className,
  label,
  size,
}) => (
  <div className={classNames('smart-page-loading-spinner', classes.loading, className)}>
    <Spinner size={size} label={label} labelPosition="right" />
  </div>
);

UnstyledLoading.defaultProps = {
  classes: {},
  className: null,
  label: '',
  size: SpinnerSize.large,
};

UnstyledLoading.propTypes = {
  classes: objectOf(any),
  className: string,
  label: string,
  size: number,
};

export const Loading = withDefaultStyles(UnstyledLoading, () => ({
  loading: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
  },
}));
